import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ms-checkbox, ' +
        'msf-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  @Input('true') valueTrue = true;

  @Input('false') valueFalse = false;

  _checked: boolean = false;

  @Output('change') onChange = new EventEmitter<any>();

  _onChange(value: any) {}

  _onTouched() {}

  @HostListener('click')
  toggle() {
    this._checked = !this._checked;
    this._onChange(this._checked ? this.valueTrue : this.valueFalse);
    this.onChange.emit(this._checked ? this.valueTrue : this.valueFalse);
  }

  constructor(private _cdr: ChangeDetectorRef) {}

  ngOnInit() {}

  writeValue(value: any): void {
    this._checked = value === this.valueTrue;
    this._cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }
}
